// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1f3Kn","bigColWidth":"Table_bigColWidth__3n7nK","biggerColWidth":"Table_biggerColWidth__2iH5J","row":"Table_row__Yltab","col":"Table_col__2r0jT"};